// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { CVC, EXPIRY, NAME, NUMBER } from '../../constants/field-names';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FormGrid = styled.div({
  display: 'grid',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  gridTemplateAreas: "'".concat(NUMBER, " ").concat(NUMBER, "' '").concat(NAME, " ").concat(NAME, "' '").concat(EXPIRY, " ").concat(CVC, "'"),
  gridTemplateColumns: '1fr 1fr',
  gridTemplateRows: 'auto',
  gridColumnGap: "var(--ds-space-200, 16px)",
  gridRowGap: "var(--ds-space-200, 16px)"
});